export const CURRENCY = [
    {
        value: 'INR',
        viewValue: 'India - INR',
    },
    {
        value: 'AED',
        viewValue: 'UAE - AED',
    },
    {
        value: 'QAR',
        viewValue: 'Qatar - QAR',
    },
    {
        value: 'SAR',
        viewValue: 'Saudi Arabia - SAR',
    },
    {
        value: 'BHD',
        viewValue: 'Bahrain - BHD',
    },
    {
        value: 'KWD',
        viewValue: 'Kuwait - KWD',
    },
    {
        value: 'OMR',
        viewValue: 'Oman - OMR',
    },
    {
        value: 'USD',
        viewValue: 'United States of America - USD',
    },
    {
        value: 'SGD',
        viewValue: 'Singapore - SGD',
    },
    {
        value: 'MYR',
        viewValue: 'Malaysia - MYR',
    },
    {
        value: 'UGX',
        viewValue: 'Uganda - UGX',
    },
    {
        value: 'TZS',
        viewValue: 'Tanzania - TZS',
    },
    {
        value: 'NGN',
        viewValue: 'Nigeria - NGN',
    },
];
